import { render, staticRenderFns } from "./DivisaoTabela.vue?vue&type=template&id=082bfbfc&lang=html&"
import script from "./DivisaoTabela.vue?vue&type=script&lang=js&"
export * from "./DivisaoTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/divisao/DivisaoTabela.vue
// module id = 1382
// module chunks = 28